// Shared geometry/types for both the per-space Timeline (Phase 7) and the org-level Portfolio
// Timeline (t12-1/t12-2) — ported directly from JIRA-ZYNX.

export type ZoomLevel = "week" | "month" | "quarter";

export const DAY_WIDTH: Record<ZoomLevel, number> = { week: 36, month: 14, quarter: 5 };
export const ROW_HEIGHT = 34;
export const LABEL_WIDTH = 260;

export const BAR_COLOR: Record<string, string> = {
  epic: "#7c3aed",
  story: "#16a34a",
  task: "#2563eb",
  bug: "#dc2626",
};

export function startOfDay(d: Date): Date {
  const c = new Date(d);
  c.setHours(0, 0, 0, 0);
  return c;
}
export function addDays(d: Date, n: number): Date {
  const c = new Date(d);
  c.setDate(c.getDate() + n);
  return c;
}
export function diffDays(a: Date, b: Date): number {
  return Math.round((startOfDay(a).getTime() - startOfDay(b).getTime()) / (1000 * 60 * 60 * 24));
}
export function isoDay(d: Date): string {
  return startOfDay(d).toISOString();
}

/** One drawable row on the chart — an epic bar, one of its children, or an unassigned issue. */
export interface TimelineRow {
  id: string;
  key: string;
  title: string;
  type: string;
  indent: boolean;
  startDate: string | null;
  dueDate: string | null;
  /** Epic rows use rolled-up dates that may not be directly editable via drag when they came from children. */
  draggable: boolean;
  linkTo: string;
  badge?: { label: string; color: string };
}

export interface TimelineSection {
  id: string;
  label: string;
  rows: TimelineRow[];
}

export interface TimelineDependencyEdge {
  blockerId: string;
  blockedId: string;
}
